<gcm-error 
    [welcomeName]="welcomeName" 
    [accountMenuItems]="accountMenuItems" 
    name="User Not Authorized" 
    description="You are not permissioned to the site you are trying to access." 
    [mailToEmailAddress]="mailToEmailAddress()"
    [emailAddressText]="emailAddressText()" 
    [buttonLinks]="buttonLinks">
</gcm-error>